var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavOffersHeart = function SvgNavOffersHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nav_offers_heart_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_offers_heart_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_heart_svg__st0",
    d: "M23.9 20.3c1.2-2.1 3.1-3.3 4.9-3.1 1.6.2 2.9 1.5 3.4 2.6 1.3 3-2.1 8-8.3 12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_heart_svg__st0",
    d: "M23.9 20.3c-1.2-2.1-3.1-3.3-4.9-3.1-1.6.2-2.9 1.5-3.4 2.6-1.3 3 2.1 8 8.3 12.5"
  }))));
};
export default SvgNavOffersHeart;